<template>
    <v-dialog max-width="600" v-model="dialog" @keydown.enter.prevent="onenter">
        <v-card>
            <v-card-title>
                <span class="headline">Decoration Bundle ({{ this.rules.name }})</span>
            </v-card-title>
            <v-card-text>
                <v-row dense class="mb-4">
                    <v-col cols="12" md="12" sm="12">
                        <v-text-field disabled label="UID:" v-model.trim="model.uid" hide-details outlined dense/>
                    </v-col>
                    <v-col cols="12" md="4" sm="4">
                        <r-smart-offer-bundle-decoration-type :model.sync="model.type" label="Type"/>
                    </v-col>
                    <v-col cols="12" md="4" sm="4">
                        <v-text-field
                          label="Name"
                          v-model.trim="model.name"
                          v-ascii-only
                        />
                    </v-col>
                    <v-col cols="12" md="4" sm="4">
                        <v-text-field
                          label="Key"
                          v-model.trim="model.key"
                          v-ascii-only
                        />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn @click="cancel" color="blue darken-1" text>
                    Cancel
                </v-btn>
                <v-btn @click="save" color="blue darken-1" text>
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import {SmartOfferBundleDecoration} from "@/modules/redactor/models/smart-offer/bundle-decoration/SmartOfferBundleDecoration";

import RSmartOfferBundleDecorationType from "@/modules/redactor/views/smart-offer/bundle-decoration/r-smart-offer-bundle-decoration-type.vue";

export default {
    name: "r-smart-offer-bundle-decoration",
    components: {RSmartOfferBundleDecorationType},
    data: () => ({
        dialog: false,
        resolve: null,
        reject: null,
        tab: null,
        model: new SmartOfferBundleDecoration(),
        rules: ViewRules.READONLY,
    }),
    computed: {
        type_code() {
            return this.model.type ? this.model.type.id : 0
        },
    },
    methods: {
        show(rules, model) {
            this.dialog = true;
            this.tab = null;
            this.rules = rules;
            this.model = model || new SmartOfferBundleDecoration();
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        save() {
            if (this.model.valid()) {
                this.resolve(this.model);
                this.discard();
            } else {
                this.$alert("Invalid config!");
            }
        },
        cancel() {
            this.reject();
            this.discard();
        },
        discard() {
            this.dialog = false;
        },
        onenter() {
            this.save();
        }
    }
}
</script>
